module.exports = __webpack_public_path__ + "img/Ambrose.2a228a38.jpg";